module.exports = __webpack_public_path__ + "img/ic_delete.2a296389.svg";